module.exports = __webpack_public_path__ + "img/img_way_06.e5dc2219.png";